// src/pages/auth/MagicLinkHandler.js - Updated with new color scheme
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Container, Typography, Alert, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { COLORS } from '../../utils/color';

const MagicLinkHandler = () => {
  const { token } = useParams(); // Get token from URL path
  const { authenticateWithMagicLink } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleMagicLink = async () => {
      if (!token) {
        setError('Invalid magic link - missing token');
        setLoading(false);
        return;
      }

      try {
        await authenticateWithMagicLink(token);
        // Redirect to dashboard after successful auth
        navigate('/dubbing', { replace: true });
      } catch (err) {
        console.error('Magic link authentication error:', err);
        setError(err.message || 'Authentication failed');
      } finally {
        setLoading(false);
      }
    };

    handleMagicLink();
  }, [token, navigate]);

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          background: COLORS.gradients.background,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Container maxWidth="sm">
          <Box sx={{ textAlign: 'center' }}>
            <CircularProgress size={60} sx={{ color: COLORS.primary.main, mb: 2 }} />
            <Typography variant="h6" sx={{ color: COLORS.text.primary, mt: 2 }}>
              Verifying magic link...
            </Typography>
            <Typography variant="body2" sx={{ color: COLORS.text.secondary, mt: 1 }}>
              Please wait while we sign you in...
            </Typography>
          </Box>
        </Container>
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          background: COLORS.gradients.background,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Container maxWidth="sm">
          <Box sx={{ textAlign: 'center' }}>
            <Alert 
              severity="error"
              sx={{
                backgroundColor: `${COLORS.status.error}20`,
                color: COLORS.status.error,
                '& .MuiAlert-icon': { color: COLORS.status.error },
                mb: 2
              }}
            >
              {error}
            </Alert>
            <Typography variant="body1" sx={{ color: COLORS.text.secondary, mb: 2 }}>
              The magic link may have expired or already been used.
            </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                color: COLORS.primary.main, 
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
              onClick={() => navigate('/signin')}
            >
              Request a new magic link
            </Typography>
          </Box>
        </Container>
      </Box>
    );
  }

  return null;
};

export default MagicLinkHandler;